module.exports = __webpack_public_path__ + "img/noReward.e3b5b860.png";